import React from "react";
import { book } from "../data/book";
export function AboutAuthor() {
  return <section id="author" className="scroll-mt-20 border-t border-line bg-night py-24 lg:py-32" data-id="element-1" data-mp="1e9yubnh2hs43">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-6 md:grid-cols-[0.8fr_1.2fr] lg:gap-20 lg:px-10" data-id="element-2" data-mp="1syvc4c8xejhw">
        <div className="relative mx-auto w-full max-w-sm" data-id="element-3" data-mp="1nz8or9zdvmvd">
          <div aria-hidden="true" className="absolute -bottom-4 -right-4 h-full w-full rounded-lg border border-gold/40" data-id="element-4" data-mp="1o1v59z495cpq" />
          <img src={book.authorPortrait} alt={`Portrait of ${book.author}`} className="relative aspect-[4/5] w-full rounded-lg bg-white object-cover object-top" data-id="element-5" data-mp="vb356qk2g3x4" />
        </div>

        <div data-id="element-6" data-mp="198ro3sukp0zj">
          <h2 className="font-serif text-sm tracking-[0.3em] text-gold" data-id="element-7" data-mp="159afwrnrhpqo">ABOUT THE AUTHOR</h2>
          <p className="mt-4 font-display text-4xl leading-tight text-cream sm:text-5xl" data-id="element-8" data-mp="15bn7lwjbnegx">
            {book.author}
          </p>
          <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-9" data-mp="2goz57pohn0un">
            Henry Bernard Dotson IV founded and sold a real-estate business, then worked in
            high-growth startups and masterminds, including a Y Combinator company.
          </p>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-10" data-mp="31l7obsar4efv">
            He ghostwrote the memoirs of three founders who built 9- and 10-figure businesses in
            restaurants, gaming, and entertainment.
          </p>
          <p className="mt-8 border-l-2 border-gold pl-6 font-serif text-2xl leading-snug text-cream" data-id="element-11" data-mp="2dtsktw78nr31">
            As a business coach, Henry helps founders see the patterns they need to beat the odds.
          </p>
        </div>
      </div>
    </section>;
}